var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "MountingPortal",
        {
          attrs: {
            "mount-to": "#skiplink_list",
            append: "",
          },
        },
        [
          _c("portal-target", {
            attrs: {
              name: "additional-skiplinks",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "portal",
        {
          attrs: {
            to: "additional-skiplinks",
          },
        },
        _vm._l(_vm.links, function (link) {
          return _c(
            "li",
            {
              key: link.url,
            },
            [
              _c(
                "button",
                {
                  staticClass: "skiplink",
                  attrs: {
                    role: "link",
                  },
                  on: {
                    click: function click($event) {
                      $event.preventDefault()
                      return _vm.goto(link.url)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                " + _vm._s(link.label) + "\n            "
                  ),
                ]
              ),
            ]
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }